import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faFileContract,
    faFileInvoiceDollar,
    faBuilding,
    faHandshake,
    faGavel,
    faBalanceScale,
    faUsers, // Zmenené z fa-family na všeobecnejšie fa-users pre "Občianske, rodinné a dedičské právo"
    faBriefcase,
    faLandmark
} from '@fortawesome/free-solid-svg-icons';

import '../styles/global.css';

const areas = [
    {
        icon: faFileContract,
        title: 'Obchodné a korporátne právo',
        desc: 'Vypracovanie, posudzovanie a pripomienkovanie obchodných zmlúv; zakladanie a zmeny obchodných spoločností a ich zápis v Obchodnom registri, registrácia partnerov verejného sektora.'
    },
    {
        icon: faFileInvoiceDollar,
        title: 'Rodinné právo',
        desc: 'Rozvodové konanie, úprava práv a povinností k maloletým deťom a vyporiadanie BSM.'
    },
    {
        icon: faBuilding,
        title: 'Prevody vlastníckeho práva k nehnuteľnostiam',
        desc: 'Vypracovanie kúpnych a darovacích a zmlúv na prevod nehnuteľností a zabezpečenie vkladu vlastníckeho práva do katastra nehnuteľností'
    },
    {
        icon: faHandshake,
        title: 'Sporová agenda a zastupovanie na mimosúdnych rokovaniach ',
        desc: 'Zastupovanie fyzických a právnických osôb pred súdmi v SR, účasť pri mimosúdnych rokovaniach a zastupovanie pri výkone rozhodnutí - exekučné konania.'
    },
    {
        icon: faGavel,
        title: 'Trestné právo',
        desc: 'Podávanie trestných oznámení; zastupovanie poškodených a obhajoba obvinených v trestnom konaní.'
    },
    {
        icon: faBalanceScale,
        title: 'Konkurzné a reštrukturalizačné právo',
        desc: 'Zastupovanie v konkurznom a reštrukturalizačnom konaní; podávanie prihlášok veriteľov; konzultácie pri insolventnosti.'
    },
    {
        icon: faUsers,
        title: 'Občianske a dedičské právo',
        desc: 'Občianskoprávna agenda, spotrebiteľské spory, zastupovanie v dedičských konaniach a s tým súvisiacich sporoch.'
    },
    {
        icon: faBriefcase,
        title: 'Pracovné právo',
        desc: 'Vypracovanie pracovných zmlúv a dohôd o prácach vykonávaných mimo pracovného pomeru; právne poradenstvo v pracovnoprávnych vzťahoch.'
    },
    {
        icon: faLandmark,
        title: 'Správne a ústavné právo',
        desc: 'Zastupovanie v administratívnych konaniach; Podávanie ústavných sťažností a zastupovanie v konaniach pred Ústavným súdom SR .'
    }
];

export default function Services() {
    return (
        <div className="services-section">
            <div className="container">
                <div className="services-intro">
                    <h2>Oblasť poskytovania právnych služieb</h2>
                    <p>zahŕňa komplexné právne poradenstvo klientom pri rôznorodých transakciách prebiehajúcich v Slovenskej republike. Medzi hlavné oblasti činnosti našej kancelárie okrem iného patria:</p>
                </div>
                <div className="areas-grid">
                    {areas.map((area, idx) => (
                        <div key={idx} className="area-card">
                            <div className="icon-wrapper">
                                <FontAwesomeIcon icon={area.icon} />
                            </div>
                            <h3>{area.title}</h3>
                            <p>{area.desc}</p>
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
}